import { render, staticRenderFns } from "./TextTooltip.vue?vue&type=template&id=b514add4&scoped=true&"
import script from "./TextTooltip.vue?vue&type=script&lang=js&"
export * from "./TextTooltip.vue?vue&type=script&lang=js&"
import style0 from "./TextTooltip.vue?vue&type=style&index=0&id=b514add4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b514add4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/vue-sellerwell-web-erp-service-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b514add4')) {
      api.createRecord('b514add4', component.options)
    } else {
      api.reload('b514add4', component.options)
    }
    module.hot.accept("./TextTooltip.vue?vue&type=template&id=b514add4&scoped=true&", function () {
      api.rerender('b514add4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TextTooltip.vue"
export default component.exports